(() => {
  const dialog = document.getElementById('JerseyWishlist');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = '4kjerseys:favorites:v1';
  const list = dialog.querySelector('[data-wishlist-list]');
  const status = dialog.querySelector('[data-wishlist-status]');
  let items = []; let accountMode = false; let accountReady = !dialog.dataset.accountEndpoint;
  const remote = async (action, item) => {
    const response = await fetch(dialog.dataset.accountEndpoint, { method: action ? 'POST' : 'GET', credentials: 'same-origin', headers: action ? {'Content-Type':'application/json'} : {}, ...(action ? {body:JSON.stringify({action,item})} : {}) });
    if (!response.ok) { const error=new Error('favorites_sync'); error.status=response.status; throw error; }
    const result=await response.json(); if(!Array.isArray(result.items)||result.items.length>50) throw new Error('invalid_response'); return result.items;
  };
  const safePath = (value) => typeof value === 'string' && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/[a-z0-9%-]+$/i.test(value);
  const safeImage = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com') ? url.href : '';
    } catch { return ''; }
  };
  const read = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '[]');
      items = Array.isArray(saved) ? saved.filter((item) => item && typeof item.id === 'string' && typeof item.title === 'string' && safePath(item.url)).slice(0, 50) : [];
    } catch { items = []; }
  };
  const sync = () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const selected = items.some((item) => item.id === button.dataset.productId);
      const label = selected ? button.dataset.labelRemove : button.dataset.labelAdd;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', label);
      const text = button.querySelector('[data-wishlist-label]');
      if (text) text.textContent = label;
      button.hidden = false; button.disabled = !accountReady;
    });
    document.querySelectorAll('[data-wishlist-open]').forEach((button) => { button.hidden = false; });
    document.querySelectorAll('[data-wishlist-count]').forEach((counter) => { counter.textContent = String(items.length); });
  };
  const render = () => {
    list.replaceChildren();
    if (!items.length) {
      const empty = document.createElement('li');
      empty.className = 'jersey-wishlist-empty';
      empty.textContent = dialog.dataset.empty;
      list.append(empty);
      return;
    }
    items.forEach((item) => {
      const row = document.createElement('li');
      row.className = 'jersey-wishlist-item';
      const image = document.createElement('img');
      const src = safeImage(item.image);
      if (src) image.src = src;
      image.alt = item.title;
      image.width = 80;
      image.height = 100;
      image.loading = 'lazy';
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = '×';
      remove.dataset.wishlistRemove = item.id;
      remove.setAttribute('aria-label', dialog.dataset.remove + ': ' + item.title);
      row.append(image, link, remove);
      list.append(row);
    });
  };
  const save = async (next) => {
    try {
      if (!accountReady) return false;
      if (accountMode) {
        accountReady=false; sync();
        const added=next.find(item=>!items.some(old=>old.id===item.id));
        const removed=items.find(item=>!next.some(value=>value.id===item.id));
        items=added ? await remote('add',added) : removed ? await remote('remove',{id:removed.id}) : items;
        accountReady=true;
      } else { localStorage.setItem(key, JSON.stringify(next)); items = next; }
      status.textContent = '';
      sync();
      render();
      return true;
    } catch {
      accountReady=true; sync();
      status.textContent = dialog.dataset.error;
      if (!dialog.open) dialog.showModal();
      return false;
    }
  };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-wishlist-toggle], [data-wishlist-open], [data-wishlist-close], [data-wishlist-remove]');
    if (!button) return;
    if (button.hasAttribute('data-wishlist-open')) {
      render();
      dialog.showModal();
      return;
    }
    if (button.hasAttribute('data-wishlist-close')) { dialog.close(); return; }
    if (!accountReady) return;
    if (button.hasAttribute('data-wishlist-remove')) {
      const id = button.dataset.wishlistRemove;
      const index = items.findIndex((item) => item.id === id);
      if (await save(items.filter((item) => item.id !== id))) {
        const remaining = list.querySelectorAll('[data-wishlist-remove]');
        (remaining[Math.min(index, remaining.length - 1)] || dialog.querySelector('[data-wishlist-close]')).focus();
      }
      return;
    }
    const id = button.dataset.productId;
    const existing = items.some((item) => item.id === id);
    if (existing) { await save(items.filter((item) => item.id !== id)); return; }
    if (!safePath(button.dataset.productUrl)) return;
    if (items.length >= 50) {
      status.textContent = dialog.dataset.limit;
      render();
      if (!dialog.open) dialog.showModal();
      return;
    }
    await save([...items, { id, title: button.dataset.productTitle, url: button.dataset.productUrl, image: safeImage(button.dataset.productImage) }]);
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  window.addEventListener('storage', (event) => {
    if (!accountMode && (event.key === key || event.key === null)) { if (!dialog.dataset.accountEndpoint) read(); sync(); render(); }
  });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('quick-view:loaded', sync);
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.matches('[data-wishlist-toggle]') || node.querySelector('[data-wishlist-toggle]'))))) sync();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  if (!dialog.dataset.accountEndpoint) read(); sync();
  if (dialog.dataset.accountEndpoint) {
    remote().then(saved=>{items=saved;accountMode=true;accountReady=true;sync();render();})
      .catch(error=>{
        if(error.status===401&&!dialog.dataset.customer){read();accountReady=true;sync();return;}
        items=[];accountReady=false;sync();render();status.textContent=dialog.dataset.error;
      });
  }
})();


